import * as THREE from 'three';
import { global } from '../../core/GlobalState';
//TODO make this much more genral and refacotr the reliance on the global state booleans 
// the systme should have the ability to make orbs orbit one another seamlessly, and also have the ability to attract orbs to a point in space. not sure if parameterized paths or physics/acceleration based is better
export function attractAllOrbs() {
    var _a;
    if (!global.attractAllMode)
        return;
    const cameraPos = global.camera.position.clone();
    const orbManager = global.orbManager;
    const shellRadius = 1600;
    const attractStrength = 0.00005;
    const repelStrength = 2;
    const repelDropoff = 2.5;
    const radialDampingFactor = 0.2; // ← Only damp radial velocity!
    for (const orb of orbManager['orbArray']) {
        if (!orb.group)
            continue;
        const orbPos = orb.group.position.clone();
        const toCamera = cameraPos.clone().sub(orbPos);
        const distance = toCamera.length();
        if (distance < 1e-4)
            continue;
        const dir = toCamera.normalize();
        const delta = distance - shellRadius;
        let force;
        if (delta > 0) {
            // --- Outside shell: pull toward shell ---
            const attractForce = attractStrength * delta;
            force = dir.multiplyScalar(attractForce);
        }
        else {
            // --- Inside shell: push outward + damp radial velocity ---
            const penetration = Math.abs(delta);
            const t = Math.min(penetration / shellRadius, 1);
            const scaledRepel = repelStrength * (1 - Math.pow(1 - t, repelDropoff));
            force = dir.negate().multiplyScalar(scaledRepel);
            // === Radial velocity damping ===
            const velocity = (_a = orb.velocity) !== null && _a !== void 0 ? _a : new THREE.Vector3();
            const radialVelocityMag = velocity.dot(dir); // projection onto radial dir
            const radialComponent = dir.clone().multiplyScalar(radialVelocityMag);
            const tangentialComponent = velocity.clone().sub(radialComponent);
            const dampedRadial = radialComponent.multiplyScalar(1 - radialDampingFactor);
            const newVelocity = tangentialComponent.add(dampedRadial);
            orb.setVelocity(newVelocity);
        }
        orb.addVelocity(force);
    }
}
